// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel-list_root__hz8Wg"};